export const RegisterTOTPButton = (bm, category, label, type) => {
  bm.add(type, {
    label: `<i class="webconnect-shield-fill-plus"></i><div>${label}</div>`,
    category: category,
    content: `<div data-gjs-type="register-totp" id="register-totp">
      <img src="https://drapcode-static.s3.amazonaws.com/img/two-factor-authentication.png" alt="totp" class="totp" />
    </div>`,
  });
};

export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, collections } = config;

  const isComponent = {
    isComponent(el) {
      if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
        return {
          type: type,
        };
      }
    },
  };

  const newModel = {
    defaults: {
      ...defaultModel.prototype.defaults,
      icon: '<i class="wb webconnect-shield-lock-fill"></i>',
      projectId,
      traits: [],
      script: function () {
        const projectId = '{[ projectId ]}';
        const totpOpts = { projectId };
        console.log('projectId', projectId);
        console.log('Going to load totp register', projectId);
        if (typeof loadTOTPComponent !== 'undefined') {
          loadTOTPComponent(this, totpOpts);
        }
      },
    },
    async init() {},
  };

  const extendModel = defaultModel.extend(newModel, isComponent);
  dc.addType(type, {
    model: extendModel,
    view: defaultView.extend(),
  });
};
